/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_AssignmentInputs */

const en_cases_col_assignment = /** @type {(inputs: Cases_Col_AssignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignment`)
};

const pt_br2_cases_col_assignment = /** @type {(inputs: Cases_Col_AssignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuição`)
};

/**
* | output |
* | --- |
* | "Assignment" |
*
* @param {Cases_Col_AssignmentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_assignment = /** @type {((inputs?: Cases_Col_AssignmentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_AssignmentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_assignment(inputs)
	return pt_br2_cases_col_assignment(inputs)
});